import React from "react";
import { Form } from "react-bootstrap";

const InputSelect = (props) => {
  const thisChange = (e) => {
    let vl = e.target.value;
    props.myOnChange(vl);
  };
  return (
    <Form.Group className="mb-3" controlId="Select">
      <Form.Label style={{ color: props.labelcolor }}>
        {props.label}
        {props.Compulsory && (
          <sup style={{ color: "Red", fontSize: "13px" }}>*</sup>
        )}
      </Form.Label>
      <Form.Control
        as="select"
        value={props.myVal ? props.myVal : ""}
        required={props.required}
        ref={props.myRef}
        onBlur={props.getTotal}
        onChange={thisChange}
        name={props.myName}
        style={{ boxShadow: "5px 5px #b1b1b1" }}
      >
        {props.myOptions.map((opt, index) => (
          <option value={opt == "Select" ? "" : opt} key={index}>
            {opt}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
};

export default InputSelect;
